<div class="registaration">
  <div class="r-header">
    <img src="assets/images/logo-dark.svg" alt="">
  </div>
  <div class="sidebar">
    <img src="assets/images/logo2.svg" class="logo" alt="">
    <h2>
      No worries! Just enter your email address and we’ll send you a link to reset your password.
    </h2>
    <img src="assets/images/r-sidebar-v.svg" class="r-sidebar-v animated" alt="">
  </div>
  <div class="form-body">
    <div class="cant-have-account">
      <a [href]="baseUrl" class="back-to-home">
        <i class="fa-solid fa-arrow-left"></i>
        <span>Go to Home</span>
      </a>
      <div class="account">
        <span>
          Don’t have an account?
        </span>
        <a [routerLink]="'/auth/signup'">
          Sign up
        </a>
      </div>
    </div>

    <form [formGroup]="ForgetPasswordForm" (ngSubmit)="sendResetLink()">
      <div class="form-card">
        <h3 class="title">
          Forget Password
        </h3>
        <p>
          No worries! Just enter your email and we'll send you a reset password link.
        </p>

        <!-- Email Input -->
        <div class="input-group position-relative">
          <input type="email" class="form-control" id="email" formControlName="email" placeholder="Email address" />
          <small class="text-danger mt-1" *ngIf="
          ForgetPasswordForm.controls['email'].invalid &&
          ForgetPasswordForm.controls['email'].touched
        ">
            <span *ngIf="ForgetPasswordForm.controls['email'].errors?.['required']">
              Email is required
            </span>
            <span *ngIf="ForgetPasswordForm.controls['email'].errors?.['email']">
              Please enter a valid email
            </span>
          </small>
        </div>

        <!-- Submit Button -->
        <button type="submit" class="btn btn-primary btn-md w-100" [disabled]="ForgetPasswordForm.invalid">
          Send Recovery Email
        </button>

        <!-- Back to Login -->
        <a [routerLink]="'/auth/login'" class="back-to-login" style="color: var(--primary-color);">
          Back to Login
        </a>
      </div>
    </form>

    <div class="download-app">
      <div class="row">
        <div class="col-lg-7">
          <h3>
            Want to partcipate in contests and win valuable prizes?
            <br>
            Download the LuQta app now!
          </h3>
        </div>
        <div class="col-lg-5">
          <div class="app-buttons">
            <a href="https://apps.apple.com/qa/app/luqta/id6752577067" terget="_blank">
              <img src="assets/images/apple.svg" class="app-btn" alt="" />
            </a>
            <a href="https://play.google.com/store/apps/details?id=io.luqta.application" terget="_blank">
              <img src="assets/images/android.svg" class="app-btn" alt="" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>